import Tooltip from "./tooltip"
import "./index.scss"

export default function initTooltips(container = document) {
  Array.from(container.querySelectorAll(".tooltip")).forEach((el) => {
    const tooltip = new Tooltip(el)
    tooltip.init()
  })
}
